import { createTheme, ThemeProvider } from "@mui/material/styles";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

// IMPORT SITES
import Home from "./pages/Home";

const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#5c0149",
    },
    secondary: {
      main: "#df360f",
    },
  },
  typography: {
    h1: {
      fontSize: 90,
      fontWeight: 500,
      lineHeight: 1.2,
      fontFamily: "Varela Round,Helvetica,Arial,sans-serif",
    },
    h2: {
      fontSize: 32,
      fontWeight: 500,
    },
    fontSize: 17,
    fontFamily: "Varela Round,Helvetica,Arial,sans-serif",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
